module.exports = __webpack_public_path__ + "static/media/shixisheng2.65923102.png";